

export enum InputPointerType {
    NONE = -1,
    PRIMARY,
    AUXILARY,
    SECONDARY,
    BACK,
    FORWARD,
    ERASE,

    NUM_VALUES = 7
}

export enum InputEventType {
    CLICK = "onClick",
    DOUBLE_CLICK = "onDoubleClick",
    LONG_CLICK = "onLongClick",
    START_DRAG = "onStartDrag",
    DRAGGED = "onDragged",
    END_DRAG = "onEndDrag",
    POINTER_HOVER = "onPointerHover",
    POINTER_DOWN = "onPointerDown",
    POINTER_MOVE = "onPointerMove",
    POINTER_UP = "onPointerUp",
    POINTER_ENTER = "onPointerEnter",
    POINTER_LEAVE = "onPointerLeave",
    POINTER_OUT = "onPointerOut",
    DOUBLE_TAP = "onDoubleTap",
    NONE = "none",
    PINCH = 'onPinch'
}

export enum InputMultiPointerEvent {
    PINCH = "onPinch",
    SWIPE = "onSwipe"
}

export enum SupportedKeyboardKey {
    CTRL = 'control'
}

export interface IScreenPoint{
    x: number;
    y: number;
    set(x: number, y: number): IScreenPoint;
    distanceTo(p: IScreenPoint): number;
    length(): number;
    copy(p: IScreenPoint): IScreenPoint;
    multiplyScalar(s: number): IScreenPoint;
    add(p: IScreenPoint): IScreenPoint;
    sub(p: IScreenPoint): IScreenPoint;
    clone(): IScreenPoint;
}

export interface ISwipeArgs {
    swipeFrom: IScreenPoint;
    swipeTo: IScreenPoint;
}

export interface IPinchArgs {
    center: IScreenPoint;
    pinchOffset: number;
}


export interface IInputEventHandler {
    handlePointerEvent(pointer: { pointerType: InputPointerType, eventType: InputEventType }, event: PointerEvent): void;
    handleMultiplePointerEvent(eventType: InputMultiPointerEvent, args: ISwipeArgs | IPinchArgs): void;
}
